// 公告预览组件
<template>
  <div class="draw-self-style">
    <el-drawer
      :visible.sync="noticeVis"
      :modal-append-to-body="true"
      size="80%"
      custom-class="drawer-self-close-btn"
      :show-close="false"
      :with-header="false"
    >
      <div class="close-btn-wrap" @click="noticeVis = false">
        <div class="btn-text">
          关闭
        </div>
      </div>
      <div class="notice-content">
        <div class="notice-title-area">
          <h1>{{ previewData.title }}</h1>
          <p class="fontColor_info">
            <span
              ><span class="fontColor_theme mr-5">{{
                previewData.update_user_name
              }}</span
              >发布于:
            </span>
            <span>{{ previewData.update_time }}</span>
            <span class="ml-20">公告分类: {{ previewData.type_label }}</span>
          </p>
        </div>
        <div class="notice-detail" v-html="previewData.notice_text"></div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    previewSign: {
      type: Number,
      default: () => 0,
    },
    previewData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      noticeVis: false,
    };
  },
  watch: {
    previewSign: function(nVal) {
      this.noticeVis = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.draw-self-style {
  ::v-deep .drawer-self-close-btn {
    overflow: visible;
    .close-btn-wrap {
      position: absolute;
      left: -40px;
      top: 200px;
      width: 40px;
      height: 140px;
      background-color: #275590;
      border: 2px solid #fff;
      border-right: none;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      .btn-text {
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 50px;
        padding: 15px 0;
        font-weight: 600;
        cursor: pointer;
      }
    }
    // 公告预览
    .notice-content {
      .notice-title-area {
        padding: 20px;
        h1 {
          font-size: 25px;
          margin-bottom: 20px;
        }
      }
      .notice-detail {
        padding: 20px;
        margin: 0 20px;
        border-top: 1px solid #ccc;

        // 暂时解决默认样式问题
        strong {
          font-size: inherit;
        }
        ul,
        li {
          list-style: initial; // 默认值
        }
      }
    }
  }
}
</style>
